import React, { Component } from "react";
import { getRoundedInrFormat } from "../../../utilities";

/*

* Constants
  
*/

const WHITE = "#fff";
const BLUE = "#009CFF";
const GREEN = "#2CCD8C";
const REVERSESIP = "reverse-sip-calculator";
const SIP = "sip-calculator";
const RD = "recurring-deposit-calculator";
const LUMPSUM = "mutual-fund-returns-calculator";
const STEPUPSIP = "step-up-sip-calculator";
const FD = "fixed-deposit-calculator";
const NPS = "nps-calculator";
const SSY = "sukanya-samriddhi-yojana-calculator";
const SWP = "swp-calculator";
const PPF = "ppf-calculator";
const NSC = "nsc-calculator";

/*

* React Class Component
  
*/
class ChartData extends React.Component {
  render() {
    const {
      investmentAmount,
      returnAmount,
      returnRate,
      duration,
      year,
      month,
      annuity,
      annuityRate,
      age
    } = this.props;
    const inMonths = Number(year) * 12 + Number(month);
    let data = [];

    if (this.props.currentCalcUrl === REVERSESIP) {
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(Number(returnAmount) * inMonths)}`
        },
        {
          color: BLUE,
          title: "Monthly SIP",
          subTitle: `₹${getRoundedInrFormat(returnAmount)}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === SIP) {
      const { year, month } = this.props;
      const inMonths = year * 12 + month;
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(investmentAmount * inMonths)}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount - investmentAmount * inMonths)
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === RD) {
      const { year, month } = this.props;
      const inMonths = Number(year) * 12 + Number(month);
      const returnAmountFinal = returnAmount - investmentAmount * inMonths;
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(investmentAmount) * inMonths
          )}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(returnAmountFinal)}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === STEPUPSIP) {
      const { year, month } = this.props;
      const inMonths = year * 12 + month;
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount.investmentAmountFinal)
          )}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount.totalAmount) -
            Number(returnAmount.investmentAmountFinal)
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === LUMPSUM) {
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(investmentAmount)}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount - investmentAmount)
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === FD) {
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(investmentAmount)}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(returnAmount)}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === NPS) {
      data = [
        {
          color: GREEN,
          title: "Lumpsum Amount",
          subTitle: `₹${getRoundedInrFormat(
            returnAmount.compoundedAmount * (1 - annuity / 100)
          )}`
        },
        {
          color: BLUE,
          title: "Annuity Amount",
          subTitle: `₹${getRoundedInrFormat(
            (returnAmount.compoundedAmount * annuity) / 100
          )}`
        },
        {
          color: WHITE,
          title: "Monthly Pension",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount.annuityAmount)
          )}`
        },
        {
          color: WHITE,
          title: "Annuity Rate",
          subTitle: `${annuityRate}%`
        }
      ];
    } else if (this.props.currentCalcUrl === SSY) {
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount.investmentAmount * 14)
          )}`
        },
        {
          color: BLUE,
          title: "Interest Earned",
          subTitle: `₹${getRoundedInrFormat(
            Number(
              returnAmount.amountAfterTwentyOneYears -
              returnAmount.investmentAmount * 14
            )
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `8.3%`
        },
        {
          color: WHITE,
          title: "",
          subTitle: ``
        }
      ];
    } else if (this.props.currentCalcUrl === SWP) {
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount ? returnAmount.investmentAmount : 0)
          )}`
        },
        {
          color: BLUE,
          title: "Future Value",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount ? returnAmount.futureValue : 0)
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${Number(returnAmount ? returnAmount.returnRate : 0)}%`
        },
        {
          color: WHITE,
          title: "Year",
          subTitle: `${Number(year)}`
        }
      ];
    } else if (this.props.currentCalcUrl === PPF) {
      const { year } = this.props;
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(investmentAmount * year)}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount - investmentAmount * year)
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else if (this.props.currentCalcUrl === NSC) {
      data = [
        {
          color: GREEN,
          title: "Investment Amount",
          subTitle: `₹${getRoundedInrFormat(investmentAmount)}`
        },
        {
          color: BLUE,
          title: "Return Amount",
          subTitle: `₹${getRoundedInrFormat(
            Number(returnAmount - investmentAmount)
          )}`
        },
        {
          color: WHITE,
          title: "Return Rate",
          subTitle: `${returnRate}%`
        },
        {
          color: WHITE,
          title: "Duration",
          subTitle: duration
        }
      ];
    } else {
      return;
    }
    return (
      <div className="w-100 flex wrap align-center space-evenly calcResultContainer">
        {[1, 2, 3, 4].map((_, ind) => (
          <Item
            color={data[ind].color}
            key={ind}
            title={data[ind].title}
            subTitle={data[ind].subTitle}
            currentCalcUrl={this.props.currentCalcUrl}
          />
        ))}
        <style jsx>{`
        .calcResultContainer{
          padding:16px 24px;
          box-sizing:border-box;
        }
        @media (max-width: 768px) {
          .calcResultContainer {
            padding: 16px;
          }
        }
        
        @media (max-width: 320px) {
          .calcResultContainer {
            justify-content: center;
          }
        }
        `}</style>
      </div>
    );
  }
}

/*

* React FC
  
*/

const Item = props => {
  return (
    <section className="flex-row justify-center align-center resultTextContainer">
      <div
        style={{
          width: "3px",
          height: "45px",
          backgroundColor: `${props.color}`,
          marginRight: "10px"
        }}
      />

      <div style={{ display: "flex", flexDirection: "column" }}>
        <p className="para-4 resultHeading">{props.title}</p>
        <p className="para-2-bold">{props.subTitle}</p>
      </div>
      <style jsx> {`
      .resultTextContainer{
        margin:8px;
      }
      .resultHeading{
        margin:0;
        margin-bottom:8px;
      }
      @media (max-width: 768px) {
        .resultTextContainer {
          justify-content: flex-start;
        }
      }
      @media (max-width: 600px) {
        .resultTextContainer {
          width: 120px;
        }
      `}</style>
    </section>
  );
};

export default ChartData;
